"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OperationBase = void 0;

var framework_1 = require("@xbox/framework");

var XalError_1 = require("../../errors/XalError");

var XalErrorType_1 = require("../../errors/XalErrorType");

var XalInternalError_1 = require("../errors/XalInternalError");

var Utils_1 = require("../Utils");

var XalInternalErrorType_1 = require("../errors/XalInternalErrorType");

var OperationBase =
/** @class */
function () {
  function OperationBase(telemetryClient) {
    this.telemetryClient = telemetryClient;
    this.completionPCS = new framework_1.PromiseCompletionSource();
  }

  OperationBase.prototype.execute = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _a;

      var _this = this;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            this.run().catch(function (error) {
              Utils_1.assert(false, error);
              var xalError = error;

              if (xalError && xalError.errorType) {
                _this.fail(xalError);
              } else {
                _this.fail(new XalError_1.XalError(XalErrorType_1.XalErrorType.UnknownError, error));
              }
            });
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , this.completionPCS.promise];

          case 2:
            _b.sent();

            return [3
            /*break*/
            , 4];

          case 3:
            _a = _b.sent();
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Object.defineProperty(OperationBase.prototype, "completionPromise", {
    get: function get() {
      return this.completionPCS.promise;
    },
    enumerable: false,
    configurable: true
  });

  OperationBase.prototype.succeed = function (result) {
    this.completionPCS.resolve(result);
  };

  OperationBase.prototype.fail = function (error) {
    var xalError = error;

    if (!xalError || !xalError.errorType) {
      Utils_1.assert(false, "Non-Xal error being passed to fail: " + error + ". Report this so it can be fixed.");
      xalError = new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.Unknown, "Unknown error occured: " + error);
    }

    this.completionPCS.reject(xalError);
  };

  return OperationBase;
}();

exports.OperationBase = OperationBase;